<template>
  <div class="media-create-page scrollable">
    <div class="page-header">
      <h1>{{ $route.meta.title }}</h1>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="mdi mdi-home-outline"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'media' }">
          Media
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="create-form">
      <el-form
          :model="formData"
          status-icon
          :rules="rulesValidate"
          ref="mediaCreateForm"
          label-width="135px"
          class="demo-ruleForm"
      >
        <el-form-item label="Loaded image">
          <div class="upload-image">
            <i class="el-icon-upload"></i>
            <input
                @change="imgReader"
                type="file"
                accept="image/jpeg,image/png"
                class="input-file"
                title="drop image here">
          </div>
        </el-form-item>
        <el-form-item label="Media">
          <el-select
              v-model="formData.model_dir_name"
              placeholder="Select a folder"
          >
            <el-option
                v-for="item in modelDirNameOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('mediaCreateForm')"
          >Save
          </el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'

export default {
  name: 'MediaCreate',
  data () {
    return {
      urlRequest: '',
      formData: {
        file: null,
        model_dir_name: ''
      },
      modelDirNameOptions: [
        {value:'posts',label:'Posts'},
        {value:'authors',label:'Authors'}
      ],
      rulesValidate: {
        name: [{required: true, message: 'Please input Meidia name. Name unique', trigger: 'blur'}],
      },
    }
  },
  methods: {
    imgReader(e) {
      this.formData.file = e.target.files[0];
    },
    submitForm () {
      this.$store.dispatch('media/createMedia',this.formData).then((resp) => {
        this.$router.push({name:"media"})
      })
    },
  },
}
</script>